import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/opt/development/izi_bi/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/development/izi_bi/layouts/default.vue").then(m => m.default || m))
}